// extracted by mini-css-extract-plugin
export default {"root":"NotificationsList_root--SLE","list":"NotificationsList_list--pv9","notification":"NotificationsList_notification--sJS"};